import * as React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { ApolloProvider } from '@apollo/react-hooks';

import { createStore } from '../store';
import { SearchFormState } from '../store/reducers';
import SearchForm, { SearchFormProps } from './SearchForm/SearchForm';
import { useGraphQLClient } from '../../graphql-client';
import { useConfig } from '../../context';
import { useRenderers } from '../../renderProps';
import Analytics from '../../Engine/components/Analytics';
import { SearchParametersFragment } from '@websky/graphql';
import { BootstrapGate } from '@shared/ui';

interface OwnProps {
	defaultParameters?: SearchParametersFragment;
}

let store: Store<SearchFormState> = null;
type Props = OwnProps & SearchFormProps;

const Component: React.FunctionComponent<Props> = props => {
	const client = useGraphQLClient();
	const { SearchFormWithStore: SearchFormWithStoreOverride = SearchForm } = useRenderers();

	const {
		SearchForm: { proMode, passengersConfig, offerHotels, offerHotelsDefaultState }
	} = useConfig();

	if (!store) {
		store = createStore(
			props.defaultParameters,
			passengersConfig,
			proMode,
			offerHotels ? offerHotelsDefaultState : false
		);
	}

	return (
		<BootstrapGate>
			<Provider store={store}>
				<ApolloProvider client={client}>
					<Analytics />

					<SearchFormWithStoreOverride {...props} />
				</ApolloProvider>
			</Provider>
		</BootstrapGate>
	);
};

export { store };

export default Component;
